import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import {
    Box,
    Button,
    DialogActions,
    DialogContent,

    TextField
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { ModalActionProps } from 'models/AutoModals';
import { CarModel } from 'models/StockModel';


type DocumentDialogProps = {
    car: CarModel,
} & ModalActionProps<{
    referenceNum?: string,
    validUntil: string,
}>

const ExpCertDataDialog = ({car, onFinish}: DocumentDialogProps) => {
    const {t} = useTranslation('cars');
    const [referenceNum, setReferenceNum] = useState(car.exportCertificate?.referenceNum);
    const [date, setDate] = useState<DateTime | null>(car.exportCertificate?.validUntil ? DateTime.fromISO(car.exportCertificate.validUntil) : null);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        onFinish({
            referenceNum,
            validUntil: date!.toISODate()!,
        });
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <TextField
                    id="referenceNum"
                    label={t('reference_number')}
                    fullWidth
                    required={car.yard?.portId === 1}
                    value={referenceNum || ''}
                    onChange={e => setReferenceNum(e.target.value)}
                />

                <DatePicker
                    label={t('validity_period')}
                    format="yyyy-MM-dd"
                    slotProps={{textField: {fullWidth: true, required: true}}}
                    onChange={d => setDate(d!)}
                    value={date}
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('save')}</Button>
            </DialogActions>


        </Box>
    );
};

export default ExpCertDataDialog;
